import { useContext } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import NodeDeleteContext from "./NodeDeleteContext";

const GroupNode = (props) => {
  const { selected, data } = props;

  const { onNodesDelete, nodes } = useContext(NodeDeleteContext);

  const handleDelete = () => {
    const findChildrens = nodes.filter((el) => props.id === el.parentId);
    const deleteArray = [props, ...findChildrens];
    onNodesDelete(deleteArray);
  };

  return (
    <div>
      {selected && (
        <DeleteIcon
          onClick={handleDelete}
          sx={{
            fontSize: "15px",
            color: "red",
            position: "absolute",
            left: -20,
          }}
        />
      )}

      <div className="input-node">
        <div>{data?.label}</div>
      </div>
    </div>
  );
};

export default GroupNode;
